import { BookMarked } from "lucide-react";
import { MENU_MASTERY_TOOLTIPS } from "../constants/menuTooltips";
import ShieldLevelIcon from "./IconComponent/ShieldLevelIcon";
import MenuIconBadge from "./MenuIconBadge";
import MenuIconTooltip from "./MenuIconTooltip";

export default function MenuMasteryNav({
  screen = "progress",
  onScreenChange = () => {},
  unreadHistoryCount = 0,
  visible = true,
}) {
  if (!visible) return null;

  const showHistoryBadge = unreadHistoryCount > 0 && screen !== "history";
  const showProgressBadge = unreadHistoryCount > 0 && screen !== "progress";

  return (
    <div className="menuFilterContainer menuMasteryNavContainer">
      <MenuIconTooltip
        tooltip={MENU_MASTERY_TOOLTIPS.progress}
        placement="left"
        portal
        className={screen === "progress" ? "filterIcon active" : "filterIcon"}
      >
        <span className="mastery-nav-icon-badge-wrap">
          <ShieldLevelIcon
            size={50}
            color="#39210d"
            strokeWidth={1}
            onClick={() => onScreenChange("progress")}
            aria-label="Progression de maîtrise"
            style={{ cursor: "pointer" }}
          />
          {showProgressBadge ? <MenuIconBadge count={unreadHistoryCount} /> : null}
        </span>
      </MenuIconTooltip>

      <MenuIconTooltip
        tooltip={MENU_MASTERY_TOOLTIPS.history}
        placement="left"
        portal
        className={`filterIcon mastery-nav-history-icon${
          screen === "history" ? " active" : ""
        }`}
      >
        <div
          className="mastery-nav-icon-badge-wrap"
          role="button"
          tabIndex={0}
          onClick={() => onScreenChange("history")}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              onScreenChange("history");
            }
          }}
          aria-label="Observateur d'évènements"
        >
          <BookMarked size={50} color="#39210d" strokeWidth={1} aria-hidden="true" />
          {showHistoryBadge ? <MenuIconBadge count={unreadHistoryCount} /> : null}
        </div>
      </MenuIconTooltip>
    </div>
  );
}
